// src/pages/HomePage.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';
import truncate from 'html-truncate';


// Importación de íconos de redes sociales
import { FaFacebook, FaTwitter } from 'react-icons/fa';

const API_EVENTS_URL = `${process.env.REACT_APP_API_URL}/api/events`;
const API_NEWS_URL = `${process.env.REACT_APP_API_URL}/api/news`;

function stripHtmlTags(html) {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
}


function HomePage() {
  const [events, setEvents] = useState([]);
  const [news, setNews] = useState([]);
  const [loadingEvents, setLoadingEvents] = useState(true);
  const [loadingNews, setLoadingNews] = useState(true);

  useEffect(() => {
    fetch(API_EVENTS_URL)
      .then((response) => response.json())
      .then((data) => {
        setEvents(data);
        setLoadingEvents(false);
      })
      .catch((error) => {
        console.error('Error fetching active events:', error);
        setLoadingEvents(false);
      });

    fetch(API_NEWS_URL)
      .then((response) => response.json())
      .then((data) => {
        const sortedNews = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setNews(sortedNews);
        setLoadingNews(false);
      })
      .catch((error) => {
        console.error('Error fetching news:', error);
        setLoadingNews(false);
      });
  }, []);

// 📌 Función para compartir en redes sociales (EVENTOS)
const shareEvent = (platform, event) => {
  let shareUrl = '';
  const eventUrl = `${process.env.REACT_APP_WEB_URL}/event/${event.id}`;
  const shortDescription = event.description ? event.description.substring(0, 100) + "..." : '';

  switch (platform) {
      case 'facebook':
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${eventUrl}&quote=${event.title} - ${shortDescription}`;
          break;
      case 'twitter':
          shareUrl = `https://twitter.com/intent/tweet?text=${event.title}: ${shortDescription}&url=${eventUrl}`;
          break;
      default:
          return;
  }

  window.open(shareUrl, '_blank', 'width=600,height=400');
};

// 📌 Función para compartir en redes sociales (NOTICIAS)
const shareNews = (platform, newsItem) => {
  let shareUrl = '';
  const newsUrl = `${process.env.REACT_APP_WEB_URL}/news/${newsItem.id}`; // 📌 Ahora redirige correctamente
  const cleanText = stripHtmlTags(newsItem.content || '');
  const shortDescription = cleanText.length > 100
    ? cleanText.substring(0, 100) + "..."
    : cleanText;
  

  switch (platform) {
      case 'facebook':
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${newsUrl}&quote=${newsItem.title} - ${shortDescription}`;
          break;
      case 'twitter':
          shareUrl = `https://twitter.com/intent/tweet?text=${newsItem.title}: ${shortDescription}&url=${newsUrl}`;
          break;
      default:
          return;
  }

  window.open(shareUrl, '_blank', 'width=600,height=400');
};




const openPopup = (item) => {
  const popup = window.open(
      '',
      '_blank',
      'width=1080,height=740,scrollbars=yes,resizable=yes'
  );

  if (popup) {
      popup.document.write(`
      <html>
        <head>
          <title>${item.title}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
              margin: 0;
              background: rgba(0, 0, 0, 0.9);
            }
            .popup-container {
              display: flex;
              flex-direction: row;
              background: white;
              border-radius: 10px;
              overflow: hidden;
              width: 1080px;
              height: 740px;
              box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
            }
            .popup-image {
              width: 60%;
              height: 100%;
              object-fit: contain;
              background: black;
            }
            .popup-content {
              width: 40%;
              padding: 20px;
              display: flex;
              flex-direction: column;
              text-align: left;
              overflow-y: auto;
            }
            .popup-title {
              margin-bottom: 10px;
            }
            .popup-text {
              margin-top: 0;
            }
            .close-btn {
              background: transparent;
              border: none;
              font-size: 24px;
              cursor: pointer;
              color: #fff;
              position: absolute;
              top: 15px;
              right: 20px;
            }
            .close-btn:hover {
              color: #ccc;
            }
          </style>
        </head>
        <body>
          <button class="close-btn" onclick="window.close()">×</button>
          <div class="popup-container">
            <img src="${item.imageUrl || '/images/default-news.jpg'}" class="popup-image" />
            <div class="popup-content">
              <h2 class="popup-title">${item.title}</h2>
              <p class="popup-text">${item.content}</p>
            </div>
          </div>
        </body>
      </html>
      `);
  }
};


  return (
    <div className="container">
    {/*<div className="event-card">
      <Link to="/crea-tu-evento">
        <img
          src="/images/rdboletas.png"
          alt="Crea tu evento"
          style={{ maxWidth: '100%', height: 'auto', maxHeight: '300px', objectFit: 'contain' }}
        />
        <span>Crea tu evento</span>
      </Link>
    </div>*/}
      <div className="events-container">
  {events.map((event) => (
    <div key={event.id} className="event-card">
      <Link to={`/event/${event.id}`}>
        <img src={event.imageUrl || '/images/concert.jpg'} alt={event.title} />
        <span>{event.title}</span>
      </Link>
      <div className="social-icons">
        <button onClick={() => shareEvent('facebook', event)}><FaFacebook /></button>
        <button onClick={() => shareEvent('twitter', event)}><FaTwitter /></button>
      </div>
    </div>
  ))}
</div>


<div className="news-container">
  <h2>Noticias y Farándula</h2>
  <table className="news-table">
    <tbody>
    {[...news].sort((a, b) => b.id - a.id).map((item) => (
        <tr key={item.id} className="news-row">
          {/* 📷 Columna izquierda: Imagen */}
          <td className="news-image-cell">
            <img
              src={item.imageUrl || '/images/default-news.jpg'}
              alt={item.title}
              className="news-image rectangular"
            />
          </td>

          {/* 📝 Columna derecha: Texto */}
          <td className="news-text-cell">
            <h3>{item.title}</h3>
            <p className="news-date">{new Date(item.createdAt).toLocaleDateString()}</p>
            <div
                dangerouslySetInnerHTML={{ __html: truncate(item.content, 300) + '...' }}
            ></div>
            <div className="social-icons">
              <button onClick={() => shareNews('facebook', item)}><FaFacebook /></button>
              <button onClick={() => shareNews('twitter', item)}><FaTwitter /></button>
            </div>          
            {/* ✅ "Ver más" ahora abre correctamente el pop-up */}
            <Link to={`/news/${item.id}`}>
              <button>Ver más</button>
            </Link>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
    </div>
  );
}

export default HomePage;
